import { IFeature, FEATURE_DEFAULTS } from '@principle-theorem/feature-flags';

export const SEEDING_FEATURE: IFeature = {
  ...FEATURE_DEFAULTS,
  label: 'seeding',
};
